import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Descontinuado",
  "Spare part list": "Lista de peças de reposição",
  "Download Excel": "Baixar o Excel",
  "Recent search list": "Lista de pesquisas recentes",
  "No data": "Não há dados",
  "spare part": "peça de reposição",
  "none": "nenhum",
  "no value": "nenhum valor",
  "No results found": "Nenhum resultado encontrado",
  "Spare parts for": "Peças de reposição para",
  "Could not load cumulated data": "Não foi possível carregar dados acumulados",
  "commissioning part": "parte de comissionamento",
  "wear part": "peça de desgaste",
  "Search": "Pesquisa",
  "Tk": "Tk",
  "Spare part number": "Número da peça de reposição",
  "drawing": "desenho",
  "Products for": "Produtos para",
  "Available": "Disponível",
  "MM": "MM",
  "The entered order code is invalid": "O código de pedido inserido é inválido",
  "Recommended": "Recomendado",
  "No data available for the entered search parameters": "Não há dados disponíveis para os parâmetros de pesquisa inseridos",
  "Search spare parts": "Pesquisar peças de reposição",
  "Order code / product root / serial number": "Código do pedido / raiz do produto / número de série",
  "Characteristic": "Característica",
  "Please enter an order code": "Digite um código de pedido",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "Com relação aos aspectos de qualidade e segurança, a Endress+Hauser recomenda enfaticamente o uso exclusivo de peças de reposição genuínas da Endress+Hauser. \nA manutenção e o reparo do instrumento só podem ser feitos por pessoal qualificado. \nA documentação do dispositivo, os padrões aplicáveis e os requisitos legais, bem como quaisquer certificados, devem ser observados!",
  "Maintenance advice": "Orientação para manutenção",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Para qual(is) produto(s) minha peça de reposição pode ser usada? O preenchimento do código de pedido da peça de reposição (por exemplo, 71002865 ou XPD0024) mostra os dispositivos relevantes nos quais essa peça de reposição pode ser usada.",
  "tool": "ferramenta",
  "Production numbers": "Números de produção",
  "New alternative": "Nova alternativa",
  "There are no items selected. Please use the checkboxes to make your selection": "Não há itens selecionados. Use as caixas de seleção para fazer sua escolha",
  "Service segmentation": "Segmentação de serviços",
  "Seg": "Seg",
  "Valid": "Válido",
  "Pos": "Pos",
  "Value": "Valor",
  "service segmentation 2": "Peças que exigem conhecimento básico. A participação bem-sucedida no treinamento básico de E+H é um pré-requisito.",
  "Phase out date": "Data de eliminação gradual",
  "service segmentation 1": "Peças que exigem conhecimento básico.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Quais peças de reposição estão disponíveis para o meu produto? O preenchimento do código do pedido (por exemplo, FTC260-AA2A1 ou PMC51-BA21JB1CGBTDJB) ou a identificação do produto (por exemplo, FTC260 ou 83F50) mostra as peças sobressalentes relevantes.",
  "Set filter": "Definir filtro",
  "Search date": "Data da pesquisa",
  "Group": "Grupo",
  "Warning": "Advertência",
  "Description": "Descrição",
  "Cancel": "Cancelar",
  "service segmentation 4": "Peças para reparo na fábrica. O conhecimento especializado é obrigatório.",
  "service segmentation 3": "Peças que exigem conhecimento especializado. A participação bem-sucedida no treinamento avançado do E+H é um pré-requisito.",
  "Drawing Position Number": "Número da posição do desenho",
  "Spare parts search": "Pesquisa de peças de reposição",
  "Confirm": "Confirmar",
  "Ordercode too short": "Código de pedido muito curto",
  "Product status": "Status do produto",
  "Open": "Aberto",
  "Clear": "Limpo",
  "PDF file with assembly instructions": "Arquivo PDF com instruções de montagem",
  "Search products": "Pesquisar produtos",
  "Export": "Exportação",
  "Production date": "Data de produção",
  "Order stop": "Parada de pedido",
  "Calibration until": "Calibração até",
  "PDF file with compatibility information": "Arquivo PDF com informações de compatibilidade",
  "Add selection to cart": "Adicionar seleção ao carrinho",
  "Mounting advices": "Conselhos de montagem",
  "Recommended parts only": "Somente peças recomendadas",
  "not applicable": "não aplicável",
  "accessories": "acessórios",
  "Cumulative spare parts list": "Lista cumulativa de peças de reposição",
  "YYYY": "YYYY",
  "Title": "Título",
  "Error": "Erro",
  "Ordercode too long": "Código de pedido muito longo",
  "Functions": "Funções",
  "Rec": "Rec",
  "Type": "Tipo",
  "Spare sensor until": "Sensor sobressalente até",
  "Spare parts until": "Peças de reposição até",
  "Filter": "Filtro",
  "Check all": "Verificar tudo",
  "Order code": "Código do pedido",
  "Repair until": "Reparo até",
  "Tag": "Etiqueta",
  "Ok": "Ok",
  "Category code": "Código da categoria",
  "Phase out": "Eliminação gradual",
  'Compatibility advices': 'Documentos adicionais',
  'Co.': 'Doc. adic.',
} as LocalizedDictionary;
